import mapboxgl from 'mapbox-gl';
import { setupMapEffects } from './mapEventHandlers';

interface MapConfigurationProps {
  container: HTMLDivElement;
  selectedLocation?: { lat: number; lng: number };
  defaultCenter?: { lat: number; lng: number };
  defaultZoom?: number;
}

export const initializeMap = async ({ 
  container, 
  selectedLocation, 
  defaultCenter, 
  defaultZoom 
}: MapConfigurationProps): Promise<mapboxgl.Map> => {
  const mapInstance = new mapboxgl.Map({
    container,
    style: 'mapbox://styles/autobotpotts/cm6co3wdn000p01sjcd417afa',
    center: selectedLocation 
      ? [selectedLocation.lng, selectedLocation.lat]
      : defaultCenter 
        ? [defaultCenter.lng, defaultCenter.lat]
        : [-98.5795, 39.8283],
    zoom: selectedLocation ? 13 : defaultZoom || 4,
    dragRotate: false,
    touchPitch: false,
    maxBounds: [[-180, -85], [180, 85]],
  });

  mapInstance.on('load', () => {
    setupMapEffects(mapInstance);
  });

  return mapInstance;
};